export const BREAKPOINT_TABLET = 768;
export const BREAKPOINT_DESKTOP = 1200;
